import React, { Component } from 'react';
import GrayNavBar           from './layout/gray-navbar';
import Router               from 'react-router'
import Parse                from 'parse';
import Api                  from '../Utils/api';
import Utils                from '../Utils/Utility';
import Spinner              from './generic/spinner';
import ForgotPassword       from './forgot-password';

let lock = require('../../img/lock.svg');

export default class Login extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            error    : "",
            isLoaded : true,
            isLoginBoxActive:true,
            isForgotPasswordBoxActive:false
        };

        this.submit = this.submit.bind(this);
        this.showForgotPasswordBox = this.showForgotPasswordBox.bind(this);
        this.showLoginBox = this.showLoginBox.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        Parse.User.logOut();
        Parse.User._clearAllState();
        Parse.User._clearCache();
    }

    componentDidMount() {
        // Utils.fetchParseConfig();
    }

    submit(e) {
        e.preventDefault();
        this.setState({ isLoaded : false });

        const username  = this.refs.username.value;
        const password  = this.refs.password.value;

        let self = this;

        if (username.length && password.length) {
            Parse.User.logOut().then(
                () => {
                    return Parse.User.logIn(username, password)
                }
            )
            .then(
                () => {
                    return Parse.User.current().fetch();
                }
            )
            .then(
                (currentUserData) => {

                    this.setState({
                        error    : "",
                        isLoaded : true
                    });

                    const { location } = this.props;
                    let currentUser    = Parse.User.current();

                    if (currentUser) {
                        if(!currentUser.get("emailVerified")){
                            this.context.router.replace({
                                pathname : '/register',
                                state    : {emailVerified : false}
                            });
                        } else if(!currentUser.get("bizId")){
                            this.context.router.replace({
                                pathname : '/register',
                                state    : {
                                    emailVerified : true,
                                    locationAdded : false
                                }
                            });
                        } else {
                            this.context.router.replace({
                                pathname  : '/dashboard',
                                state     : {
                                    afterLogin : true
                                }
                            });
                        }
                    } else if (location.state && location.state.nextPathname) {
                        this.context.router.replace(location.state.nextPathname);
                    } else {
                        this.context.router.replace({
                            pathname  : '/dashboard',
                            state     : {
                                afterLogin : true
                            }
                        });
                    }
                },
                (error) => {
                    console.log(error);
                    this.setState({
                        error    : 'Incorrect username or password',
                        isLoaded : true
                    });
            });
        } else {


            if(Utils.isEmpty(username)){
                this.setState({
                    error    :  "Please enter the valid email",
                    isLoaded : true
                });

                return;
            }

            if(Utils.isEmpty(password)){
                this.setState({
                    error    : "Please enter the password",
                    isLoaded : true
                });

                return;
            }

        }
    }

    showForgotPasswordBox(){

        this.setState({
            isLoginBoxActive:false,
            isForgotPasswordBoxActive:true
        })

    }

    // remove error message
    handleChange(){
        this.setState({
            error: "",
        })
    }

    showLoginBox() {
        this.setState({
            isLoginBoxActive: true,
            isForgotPasswordBoxActive: false,
            error:""
        });
    }

    render() {
        return (

            <div className={"bg-section"}>
                <GrayNavBar/>
                { !this.state.isLoaded ? <Spinner /> : null }
                <div className="section login-pg">
                    {
                        this.state.isLoginBoxActive ? (
                            <div className="container">

                                <div className="row">
                                    <div className="col-md-12">
                                        <h1 className="text-center header-text">
                                            Welcome to your Restaurant Dashboard!
                                        </h1>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-center-block login-container mt-20">
                                        <form onSubmit={this.submit} role="form">
                                            <div className="form-group">
                                                <label
                                                    id        =  "username"
                                                    className =  {"text-white forgot-pass-text"}
                                                    style     =  {{letterSpacing: "2px", fontWeight: "500"}}
                                                >
                                                    Email Address
                                                </label>
                                                <input
                                                    ref             = "username"
                                                    aria-labelledby = "username"
                                                    className       = "form-control forgot-pass-text"
                                                    type            = "email"
                                                    onChange        = {this.handleChange}
                                                />

                                            </div>
                                            <div className="form-group">
                                                <label
                                                    id        =  "password"
                                                    className =  {"text-white forgot-pass-text"}
                                                    style     =  {{letterSpacing: "2px", fontWeight: "500"}}
                                                >
                                                    Password
                                                </label>
                                                <input
                                                    className       = "form-control forgot-pass-text"
                                                    aria-labelledby = "password"
                                                    ref             = "password"
                                                    type            = "password"
                                                    onChange        = {this.handleChange}
                                                />

                                                {!Utils.isEmpty(this.state.error) ? (
                                                    <div className="login-error-container form-text mb-5" style={{color: "red"}}>
                                                        <i className="fa fa-warning" style={{color: "white"}} aria-hidden="true"></i>
                                                        <span className="ml-5 text-white forgot-pass-text">{this.state.error}</span>
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="form-group text-center forgot-pass-text mt-25">
                                                <button type="submit" className="btn">Login</button>
                                            </div>

                                            <div className="forgot-pass-text" style={{fontSize: '16px',color:'#ffffff',textAlign:'center',marginTop:'15px', marginBottom: "8px"}}>
                                                <a href="JavaScript:void(0)" style={{color:'#ffffff'}} onClick={this.showForgotPasswordBox}>Forgot password?</a>
                                            </div>

                                        </form>

                                    </div>

                                </div>

                            </div>
                        ) : null
                    }
                    {
                        this.state.isForgotPasswordBoxActive ? (
                            <div className="container">
                                <ForgotPassword
                                    showLoginBox = {this.showLoginBox}
                                ></ForgotPassword>

                            </div>
                        ) : null
                    }
                </div>
            </div>

        );
    }
}




// WEBPACK FOOTER //
// src/components/login.js